import React from "react";
import { BookListContainer } from "../../../components";
import { Dispatcher, LibraryStore } from "../../../flux";

export default class Library extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      window: { width: $("#book-list").width(), height: window.innerHeight },
      view: Fraction.Brand.Library.defaultView
    };
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(Dispatcher.LIBRARY_UPDATED, this._booksUpdated);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.LIBRARY_UPDATED, this._booksUpdated);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  componentDidMount() {
    this.header.focus();
    this._booksUpdated();
  }

  _booksUpdated() {
    const books = LibraryStore.get().bookList;
    this.setState({ books });
  }

  render() {
    return (
      <div id="assignment-creator-library">
        <h3
          tabIndex={-1}
          ref={header => {
            this.header = header;
          }}
          className="choose-book-text"
        >
          {i18n.t("assignments.choose-book")}
        </h3>
        <div>
          <BookListContainer
            window={this.state.window}
            view={this.state.view}
            books={this.state.books}
            openAssignmentCreator={true}
            unavailableTypes={["dash"]}
            unavailableMessage={i18n.t("assignments.unavailable-book")}
          />
        </div>
      </div>
    );
  }
}
